import { useContext } from 'react';
import { FormContextType } from '../../types';
import { FormContext } from '../helpers/context';

export const useClientForm = (): FormContextType => {
	const context = useContext(FormContext);
	if (!context) {
		throw new Error('useClientForm must be used within a FormProvider');
	}
	return context;
};
